export const ILLION_PRE_SUBMIT_ADR = 'bankStatement';
export const ILLION_POST_SUBMIT_ADR = 'collectUpToDateCopiesOfBankStatements';
